"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_TILE_OLD_PRICE = exports.PRODUCT_TILE_IMAGE_PLACEHOLDER = exports.PRODUCT_TILE_CURRENT_PRICE = exports.PRODUCT_TILE_BUNDLES_IMAGES = exports.PRODUCT_TILE = void 0;
const PRODUCT_TILE = exports.PRODUCT_TILE = 'productTile';
const PRODUCT_TILE_CURRENT_PRICE = exports.PRODUCT_TILE_CURRENT_PRICE = 'productTileCurrentPrice';
const PRODUCT_TILE_OLD_PRICE = exports.PRODUCT_TILE_OLD_PRICE = 'productTileOldPrice';
const PRODUCT_TILE_BUNDLES_IMAGES = exports.PRODUCT_TILE_BUNDLES_IMAGES = 'productTileBundlesImages';
const PRODUCT_TILE_IMAGE_PLACEHOLDER = exports.PRODUCT_TILE_IMAGE_PLACEHOLDER = 'productTileImagePlaceholder';
